/**
 * Chart module constants.
 */

// Timeframe buckets allowed per frequency. The backend always receives a bucket
// token that matches the data cadence the user sees, so short buckets are
// flagged invalid for long frequencies (they would produce zero or one data
// points).
//
// Read as: "if the user picked `weekly`, the `1h`/`3h`/`1d`/`1w` pills make
// no sense — disable them". The pills are still rendered so the user can see
// what's available. `custom` is always allowed (free-form date window, but
// still bound by MIN_DATA_POINTS at the picker).
export const ALLOWED_TIMEFRAMES_BY_FREQUENCY = {
  daily:     ['1d', '1w', '1m', '3m', '1y', '5y', 'max', 'custom'],
  weekly:    ['1m', '3m', '1y', '5y', 'max', 'custom'],
  monthly:   ['1y', '5y', 'max', 'custom'],
  quarterly: ['5y', 'max', 'custom'],
  yearly:    ['max', 'custom'],
};

// When the user changes frequency and the current timeframe is no longer valid,
// snap to this default — the first valid bucket that still produces a useful
// chart ("show the last N of whatever they picked").
export const DEFAULT_TIMEFRAME_BY_FREQUENCY = {
  daily:     '1y',
  weekly:    '1y',
  monthly:   '5y',
  quarterly: '5y',
  yearly:    'max',
};

// Minimum number of data points the chart needs to render meaningfully.
// Pills/custom-ranges that would yield fewer than this are disabled (still
// rendered, but greyed out and unclickable). Spec: "ensure adequate
// information on the chart screen".
export const MIN_DATA_POINTS = 5;

// Length of one bucket at each visual frequency, in milliseconds. Used to
// estimate how many points a given date window will contain so we can
// pre-emptively disable pills / the custom-range Apply button.
export const FREQUENCY_PERIOD_MS = {
  daily:     24 * 60 * 60 * 1000,
  weekly:    7 * 24 * 60 * 60 * 1000,
  monthly:   30 * 24 * 60 * 60 * 1000,
  quarterly: 90 * 24 * 60 * 60 * 1000,
  yearly:    365 * 24 * 60 * 60 * 1000,
};

// Width of each pill in milliseconds (window from "now" backward). `max` and
// `custom` aren't pre-defined — `max` uses the full overview range, `custom`
// uses the user's picked dates.
export const PILL_WINDOW_MS = {
  '1h': 60 * 60 * 1000,
  '3h': 3 * 60 * 60 * 1000,
  '1d': 24 * 60 * 60 * 1000,
  '1w': 7 * 24 * 60 * 60 * 1000,
  '1m': 30 * 24 * 60 * 60 * 1000,
  '3m': 90 * 24 * 60 * 60 * 1000,
  '1y': 365 * 24 * 60 * 60 * 1000,
  '5y': 5 * 365 * 24 * 60 * 60 * 1000,
};
